import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const OFFICIAL_URL = "https://toledoconsultora.com";

export const Footer = () => {
  useEffect(() => {
    const footerElement = document.getElementById("main-footer");
    if (footerElement) {
      footerElement.setAttribute("data-ai-content", "footer");
      footerElement.setAttribute("data-bot-friendly", "true");
    }
  }, []);

  return (
    <>
      <footer id="main-footer" className="footer-main" role="contentinfo">
        <div className="footer-container">
          <div className="footer-column footer-about">
            <h3 className="footer-title">
              <a
                href={OFFICIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                Toledo Consultora IT
              </a>
            </h3>
            <p className="footer-description">
              Desarrollo de software, ciberseguridad, inteligencia artificial
              aplicada y SEO para empresas de Argentina, España y Paraguay.
            </p>
            <p className="footer-text-small" style={{ marginTop: "0.75rem" }}>
              Sitio oficial:
              {" "}
              <a
                href={OFFICIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                toledoconsultora.com
              </a>
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-subtitle">Servicios</h4>
            <nav className="footer-nav">
              <Link to="/nuestros-servicios" className="footer-link">Nuestros Servicios</Link>
              <Link to="/about-posicionamiento" className="footer-link">Posicionamiento SEO</Link>
              <Link to="/about-google-ads" className="footer-link">Google Ads</Link>
              <Link to="/about-redes-sociales" className="footer-link">Redes Sociales</Link>
              <Link to="/about-landing-page" className="footer-link">Landing Pages</Link>
              <Link to="/servicios-profesionales" className="footer-link">Servicios Profesionales</Link>
            </nav>
          </div>

          <div className="footer-column">
            <h4 className="footer-subtitle">Empresa</h4>
            <nav className="footer-nav">
              <Link to="/acerca-de-nosotros" className="footer-link">Acerca de Nosotros</Link>
              <Link to="/nuestros-proyectos" className="footer-link">Nuestros Proyectos</Link>
              <Link to="/e-book-gratuito" className="footer-link">E-Book Gratuito</Link>
              <Link to="/sistema-5-5" className="footer-link">Sistema 5/5</Link>
              <Link to="/contacto" className="footer-link">Contacto</Link>
              <Link to="/indice-del-sitio" className="footer-link">Mapa del Sitio</Link>
            </nav>
          </div>

          <div className="footer-column">
            <h4 className="footer-subtitle">Legal</h4>
            <nav className="footer-nav">
              <Link to="/terminos-y-condiciones" className="footer-link">Términos y Condiciones</Link>
              <Link to="/condiciones-de-aceptacion-del-servicio" className="footer-link">Condiciones de Aceptación del Servicio</Link>
              <Link to="/politica-de-seguridad" className="footer-link">Política de Seguridad</Link>
              <Link to="/politica-de-privacidad" className="footer-link">Política de Privacidad</Link>
              <Link to="/politica-de-cookies" className="footer-link">Política de Cookies</Link>
              <Link to="/aviso-legal" className="footer-link">Aviso Legal</Link>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div>
              <p className="footer-copyright">
                © 2026 Toledo Consultora IT. Todos los derechos reservados. Diseñado, Desplegado y Mantenido por{" "}
                <a
                  href={OFFICIAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  toledoconsultora.com
                </a>
              </p>
              <div className="footer-seo-links" style={{ gap: "0.75rem", flexWrap: "wrap" }}>
                <Link to="/condiciones-de-aceptacion-del-servicio" className="seo-link">Aceptación del Servicio</Link>
                <span aria-hidden="true">•</span>
                <Link to="/politica-de-seguridad" className="seo-link">Seguridad</Link>
                <span aria-hidden="true">•</span>
                <Link to="/politica-de-privacidad" className="seo-link">Política</Link>
                <span aria-hidden="true">•</span>
                <Link to="/politica-de-privacidad" className="seo-link">Privacidad</Link>
                <span aria-hidden="true">•</span>
                <Link to="/politica-de-cookies" className="seo-link">Cookies</Link>
              </div>
            </div>

            <div className="footer-seo-links">
              <a href={`${OFFICIAL_URL}/sitemap.xml`} className="seo-link" rel="nofollow">
                Sitemap XML
              </a>
              <a href={`${OFFICIAL_URL}/robots.txt`} className="seo-link" rel="nofollow">
                Robots.txt
              </a>
            </div>
          </div>
        </div>

        <div itemScope itemType="https://schema.org/Organization" style={{ display: "none" }}>
          <span itemProp="name">Toledo Consultora IT</span>
          <link itemProp="url" href={OFFICIAL_URL} />
          <span itemProp="email">ventas@toledoconsultora.com</span>
          <span itemProp="telephone">+54 3764221063</span>
          <span itemProp="address">C.52 / 22, Posadas, Misiones, Argentina</span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
